module.exports = __webpack_public_path__ + "img/add-new-marketing-member-yellow.e5d649b9.svg";